const axios = require("axios");
const genkeys = require("rezauthlib");
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
import Swal from "sweetalert2";

export default {
  data() {
    return {
      rememberDevice: false
    };
  },
  methods: {
    async auto_remember_device() {
      const enabledBrands = process.env.VUE_APP_REMEMBER_DEVICE_BRANDS ? 
        JSON.parse(process.env.VUE_APP_REMEMBER_DEVICE_BRANDS) : ["AIR"];
      
      if (enabledBrands.includes(this.setbrandid)) {
        await this.autologin_remember_device();
      }
    },
    
    async handle_remember_device(uuid, email) {
      if (!this.rememberDevice) return;
      
      try {
        const RememberDevice = await import("@/modules/RememberDevice");
        await RememberDevice.default.rememberDevice(uuid, email);
        console.log("Device remembered successfully");
      } catch (error) {
        console.error("Error remembering device:", error);
      }
    },
    
    async extend_remembered_device() {
      try {
        const RememberDevice = await import("@/modules/RememberDevice");
        await RememberDevice.default.extendRememberedDevice();
        console.log("Device extended successfully");
      } catch (error) {
        console.error("Error extending device:", error);
      }
    },
    
    async autologin_remember_device() {
      try {
        const RememberDevice = await import("@/modules/RememberDevice");
        
        console.log("Checking for remembered device...");
        
        const lastLoginTime = localStorage.getItem("lastLogin");
        const emailEntered = sessionStorage.getItem("emailEntered");
        const userId = sessionStorage.getItem("userId");
        
        if (lastLoginTime && emailEntered && userId) {
          console.log("Found previous login data, setting up remember device");
          await RememberDevice.default.rememberDevice(userId, emailEntered);
        }
        
        const deviceData = await RememberDevice.default.isDeviceRemembered();
        console.log("Device remembered status:", deviceData ? "found" : "not found");
        
        if (deviceData && deviceData.email) {
          console.log("Using remembered device data");
          if (this.emailid !== undefined) this.emailid = deviceData.email;
          if (this.ValidateEmail && typeof this.ValidateEmail === 'function') {
            this.emailValid = this.ValidateEmail(deviceData.email);
            this.emailInvalid = !this.emailValid;
          }
          
          if (deviceData.userId) {
            try {
              if (!sessionStorage.getItem("session_uuid")) {
                Swal.fire({
                  title: "Info",
                  icon: "info",
                  text: "Attempting Login in please wait...",
                  showConfirmButton: false,
                  showCloseButton: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                });
              }
              
              console.log("Attempting auto-login");
              await RememberDevice.default.extendRememberedDevice();
              
              sessionStorage.setItem("userId", deviceData.userId);
              sessionStorage.setItem("emailEntered", deviceData.email);
              
              this.remember_log(deviceData.userId);
            } catch (loginErr) {
              console.log("Auto-login failed:", loginErr);
              Swal.close();
            }
          }
        }
      } catch (e) {
        console.log("Remember device error:", e);
      }
    },
    
    remember_log(userId) {
      let uuid = userId;
      let datasearch = {
        slug: this.setbrandid,
        uid: uuid,
      };
      let secsaa = {};
      if (this.setbrandid == "HER") {
        secsaa = genkeys(
          process.env.VUE_APP_USERDET_SECRETID_FRA,
          process.env.VUE_APP_USERDET_SECRETKEY_FRA
        );
      } else {
        secsaa = genkeys(
          process.env.VUE_APP_USERDET_SECRETID,
          process.env.VUE_APP_USERDET_SECRETKEY
        );
      }
      let b1sa = secsaa.b1s;
      let v2sa = secsaa.v2s;
      let a1a = secsaa.a1;
      let v1a = secsaa.v1;
      let c2sa = secsaa.c2s;
      let uidgena = secsaa.uidgen;
      let ur = "";
      if (this.setbrandid == "HER") {
        ur = process.env.VUE_APP_DOMAIN_DEVAWS_FRA;
      } else {
        ur = process.env.VUE_APP_DOMAIN_DEVAWS;
      }
      axios
        .post(ur + "userdetails/", datasearch, {
          headers: {
            b1: b1sa,
            v2: v2sa,
            c2s: c2sa,
            a1: a1a,
            v1: v1a,
            c1: uidgena,
          },
        })
        .then(
          (response) => {
            let userdatasent = JSON.parse(response.request.response);
            if (userdatasent.user_exists == "Y") {
              let userdata = userdatasent.result[0];
              // The CP1 user-details response uses firstname/lastname while
              // the shared header and checkout state use first_name/last_name.
              userdata = {
                ...userdata,
                first_name: userdata.first_name ?? userdata.firstname ?? "",
                last_name: userdata.last_name ?? userdata.lastname ?? "",
              };
              if (this.$cookie && this.$cookie.setCookie) {
                this.$cookie.setCookie("guid_token", uuid, {
                  expire: 300 * 60,
                });
              }
              
              localStorage.setItem("userId", uuid);
              
              if (this.setLocalData && typeof this.setLocalData === 'function') {
                this.setLocalData(
                  "accessToken",
                  Date.now().toString(36) + Math.random().toString(36).substr(2)
                );
                this.setLocalData(
                  "refreshToken",
                  Date.now().toString(36) + Math.random().toString(36).substr(2)
                );
                this.setLocalData("emailEntered", userdata.email);
                this.setLocalData("lastLogin", Date.now());
              }
              
              sessionStorage.setItem("session_uuid", uuid);
              if (typeof encryptStorage !== 'undefined') {
                encryptStorage.setItem("session_userdata", userdata);
              }
              window.dispatchEvent(new CustomEvent("userLoggedIn"));
              if (this.updateHeader !== undefined) this.updateHeader++;
              Swal.close();
            }
          },
          (error) => {
            console.log(error);
            Swal.close();
          }
        );
    }
  }
};
